<template>
  <div class="app-container">
    <div class="rowContainer">
      <div class="treeSide">
        <div class="resize-bar"></div>
        <div class="resize-line"> <svg-icon class-name="dragIcon" icon-class="dragIcon"></svg-icon></div>
        <div class="resize-save">
          <user-tree :get-tree-options="getTreeOptions" height="calc(100vh - 190px)" :show-action-but="false"
          :show-refresh="true" :show-search="true" :draggable="true" :loading="treeLoading"
          :add-child-fun="handleAppChildNode" :update-fun="handleUpdate" :delete-fun="handleDelete"
          :cancel-cur-select="false" :is-fefresh-child-node="refreshChildNode" :refresh-node-data="refreshNodeData"
          @getTreeRef="getUserTreeRef" @onNodeClick="handleNodeClick" @onRefreshTree="getTreeOptions"
          @cancelCurSelect="treeCancelCurSelect" @getTreeOpts="getTreeOpts"
          @onRefreshChildNodeSuccess="onRefreshChildNodeSuccess" />
        </div>
      </div>
      <div class="mainContent">
        <el-row v-show="selectVals.length == 0" class="table-top-btn-container mb8">
          <el-col :span="2">
            <el-button type="primary" :disabled="disabledAdd" @click="handleAdd(curParentNode)" v-hasPermi="['system::mechanismManage::add']">添加节点
            </el-button>
          </el-col>
        </el-row>
        <Table
            :data="tableList"
            ref="tableChildRef"
            :columns="tableColumns"
            maxHeight="500"
            :total="curTotal"
            :loading="loading"
            :showFun="true"
            :isSelect="true"
            rowKey="applicationFormId"
            @onSearch="findTableChildData"
            :customParamsFun="getCustomParamsFun"
          >
          </Table>
      </div>
    </div>
    <!-- 添加或修改用户对话框 -->
    <el-dialog :title="title" v-model="dialogOpen" width="600px" append-to-body>
      <el-form ref="dialogFormRef" :model="dialogFormData" :rules="dialogFormRules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="organName">
              <el-input  v-model="dialogFormData.organName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="organType">
              <el-select v-model="dialogFormData.organType" disabled clearable placeholder="请选择类型">
                <el-option v-for="item in nodeTypeList.slice(nodeTypeIndex)" :key="item.libraryCode"
                  :label="item.libraryName" :value="item.libraryCode" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="地址" prop="">
              <el-input  v-model="dialogFormData.nodeAddress" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="">
              <el-input type="textarea" rows="5"  v-model="dialogFormData.remark"
                placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!--            <Gaodemap :width="580" :draggable="true" :clicked-update-lng-lat="true" :show-search="true"></Gaodemap>-->
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 关联仓库 -->
    <el-dialog title="仓库权限" v-model="dialogOpen_ck" width="500px" append-to-body>
        <el-form :model="distributeDataForm" label-width="80px">
          <el-form-item label="部门名称">
            <el-input v-model="distributeDataForm.organName" :disabled="true" />
          </el-form-item>
          <el-form-item label="仓库权限">
            <el-tree ref="distributeTreeRef" class="tree-border" :data="distributeOptions" show-checkbox
              default-expand-all node-key="warehouseId" empty-text="暂无数据" :props="distributeProps"></el-tree>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closedDistribute">{{ $t('msg.universal.cancel') }}</el-button>
            <el-button type="primary" @click="onConfirmDistribute">{{ $t('msg.universal.confirm') }}</el-button>
          </span>
        </template>
      </el-dialog>
    <!-- 删除失败的节点 -->
    <Dialog :title="dialogTitle" v-model="deleteNodeErrDialogOpen" width="800px">
      <template #content>
        <Table ref="deleteNodeErrTableRef" class="mb5"  maxHeight="500" :data="deleteNodeErrTableData"
          :columns="deleteNodeErrTableCols" :showFun="false" :isSelect="false" />
      </template>
      <template #footer>
        <el-button  type="primary" @click="handleCloseDeleteNodeErrDialog">关闭</el-button>
      </template>
    </Dialog>

  </div>
</template>

<script setup>
import {  onMounted, ref, watch } from "vue";
import usePermissionStore from "@/store/modules/permission";
import useAccountStore from "@/store/modules/account";
import {
  findRootNodeByNodeType,
  nodeAdd,
  deleteNodeInfoBatch,
  nodeUpdate
} from "@/api/system/mechanism";
import {newGetSimpleTress } from "@/api/system/organ";
// import FileUpload from "@/components/uploadDownload/fileUpload"
import { getCustomTableCols } from "@/tableColumn";
import { alertBox, confirmBox, succesMsg, warnMsg } from "@/utils/msgBox.ts";
import { getNodeTypeIndex, getNodeTypeList } from "@/utils/cache";
import UserTree from "@/components/userTree"
import { assignmentSelfProp, isNull, setParentId } from "@/utils/fangerUtils";
import Table from "@/components/Element/Table";
import Dialog from "@/components/Element/Dialog"
import { selectWarehouseOrganRel,updateWarehouseOrganRel } from "@/api/warehouse/warehouse";
import useCacheStore from "@/store/modules/cache";
import { joinComma } from "@/utils/stringutil";
const cacheStore = useCacheStore();
const { warehouse } = cacheStore;
const isShowUser = ref(false)

const store = usePermissionStore()
const store_user = useAccountStore()
// 表格参数
const disabledAdd = ref(false)
// 树结构参数
const treeOptions = ref([])
const treeLoading = ref(false)
const rootNode = ref(null)  // 根节点
const curParentNode = ref(null)
const refreshChildNode = ref(false)
const refreshNodeData = ref({})
const distributeProps = {
  children: 'children',
  label: 'warehouseName'
}
defineOptions({
    name: "userManage",
  })
const distributeOptions = ref()
// 获取权限仓库
const getAllOperation = (val) => {
   selectWarehouseOrganRel({organId:val}).then(resDate =>{
    distributeTreeRef.value.setCheckedKeys(resDate, false)
  })
}


let userTreeRef = null

const getUserTreeRef = treeRef => {
  userTreeRef = treeRef
}

// 获取根节点
const getRootNode = async () => {
  await findRootNodeByNodeType().then(resData => {
    rootNode.value = resData.data
  })
  return rootNode.value
}
// 获取节点树
const getTreeOptions = async () => {
  treeOptions.value =  await newGetSimpleTress().then(resData => {
    treeLoading.value = false
    store.permissionTrees=resData.data
    const expandData = filterExpandData(resData.data)
    return expandData
  })
  return treeOptions.value

}
// getTreeOptions() // 获取树节点
const filterExpandData=(data)=>{
  data?.forEach(item=>{
    if(item.hasChild == '1'){
      let child = [{
          organId: "xnzjd0001" + item.organId,
          organName: "正在加载",
          child: []
      }]
      item.child=child
    }
  })
  return data
}
// 节点被点击
const curNodeOri = ref(null)
const nodeClickFlag = ref(false) // 按钮点击标志

const handleNodeClick = async (data, nodeItem) => {
  curNodeOri.value = nodeItem
  if (curNodeOri.value) {
    refreshNodeData.value = curNodeOri.value.data
    // refreshChildNode.value = true
  }
  // 点击节点上的按钮，修改点击状态返回
  if (nodeClickFlag.value) {
    nodeClickFlag.value = false
    return
  }
  curParentNode.value = data
  updateTable() // 获取表格数据
}

// 点击取消当前选择
const treeCancelCurSelect = () => {

  curParentNode.value = null
  updateTable() // 获取表格数据
}

// 获取树节点数据
const getTreeOpts = (treeOpts) => {
  treeOptions.value = treeOpts
}
// 刷新子节点完成
const onRefreshChildNodeSuccess = () => {
  refreshChildNode.value = false
  treeLoading.value = false
}

// 获取表格子数据
const findTableChildData = data => {
  _findTableData(data)

}

// 查询表格数据
const _findTableData = async data => {
  curPage.value = data.pageIndex
  curSize.value = data.pageSize
  let __curParentNode = data.curParentNode
  // delete data.curParentNode
  if ( (__curParentNode === null || __curParentNode === undefined) && !data.whereSql &&!data.sort ) {
     getRootNode().then(resData => {
      tableList.value = resData
      curTotal.value = resData.length
      disabledAdd.value = true
    })
    return
  }
  findRootNodeByNodeType(__curParentNode.organId).then(resData => {
    if(__curParentNode.isCanAdd == '1'){
      disabledAdd.value = false
    }else{
      disabledAdd.value = true
    }
    tableList.value = resData.data
    // if(resData.data.length>0 && resData.data[0].isCanAdd == '1'){
      
    // }
    // curTotal.value = resData.pageParam.totleInfo
  }).finally(() => {
    loading.value = false
  })
  

}

// 获取当前节点和父节点的类型
const getParentNodeNodeType = (node, nodeDict) => {
  nodeDict[`${node.data.organType}Id`] = node.data.organId
  if (node.parent !== null && !(node.parent.data instanceof Array)) {
    getParentNodeNodeType(node.parent, nodeDict)
  }
}


// 表格数据
const loading = ref(false)
const tableList = ref([])
const tableChildRef = ref(null)

const nodeTypeIndex = ref(0)
const nodeTypeList = getNodeTypeList()


const tableHeight = ref("calc(100vh - 199px)")


const updateTable = () => {

  tableChildRef.value.onSearch()
}

let addChild2ParentData = null  // 保存添加子节点的父节点数据

const handleAppChildNode = row => {
  updateTable() // 获取表格数据
  handleAdd(row) // 显示添加节点框
}
const getCustomParamsFun = () => {
  return {
    curParentNode: curParentNode.value
  }
}


// 添加
const handleAdd = row => {
  formDataReset() // 清空表单数据
  title.value = '新增用户'
  nodeTypeIndex.value = 1
  if (!isNull(row?.organType)) {
    nodeTypeIndex.value = getNodeTypeIndex(row.organType) + 1
  }
  dialogFormData.value.organType = nodeTypeList[nodeTypeIndex.value].libraryCode
  dialogFormData.value.operatorName = store_user.userInfo.userAccount
  dialogFormData.value.floor = 1
  dialogFormData.value.nodeNatures = "1"
  dialogOpen.value = true

  addChild2ParentData = row

}

const curUpdateData = ref(null)
let curUpdateNode = null
// 修改
const handleUpdate = (row, node) => {
  formDataReset() // 清空表单数据
  title.value = '修改用户'
  curUpdateData.value = node
  curUpdateNode = row
  dialogFormData.value = { ...node }
  nodeTypeIndex.value = getNodeTypeIndex(node.organType)
  dialogFormData.value.operatorName = store_user.userInfo.userAccount

  dialogOpen.value = true

}
// 删除
const handleDelete = (row, node) => {
  confirmBox('是否确定要删除').then(async () => {
    // 判断是否包含子节点
    let isHasChild = await findRootNodeByNodeType(node.organId).then(resData => {
      if (resData.data.length > 0) {
        return true
      } else {
        return false
      }
    })
    if (isHasChild) {
      alertBox('当前节点包含子节点无法进行删除，请先删除子节点！', '确定', 'warning')
      return
    }

    let resStatus = false
    await deleteNodeInfoBatch(node.organId).then(resData => {
      if (resData.status === 1) {
        resStatus = true
      }
    })
    let __curParentNode = null
    if (node?.parent?.data) {
      // 设置curParentNode 为当前节点的父节点
      __curParentNode = node.parent.data
    }
    if (resStatus) {
      succesMsg("删除成功")
      updateTable()// 更新表格数据
      getTreeOptions() //刷新树
      if (__curParentNode?.organType === 'root') {
        let index = findArrayIndex(treeOptions.value, row.organId, 'organId')
        if (index > -1) {
          treeOptions.value.splice(index, 1)
        }
      } else {
        // 更新树结构数据
        refreshNodeData.value = __curParentNode
        refreshChildNode.value = true

      }
    } else {
      warnMsg('删除失败')
    }
  }).catch(err => {

  })
}
const selectVals = ref([])
// 批量删除
const handleBatchDelete = () => {
   selectVals.value = tableRef.value.getSelectedRows();
  confirmBox(`是否确定要批量删除当前选中的 ${selectVals.value.length} 个节点 `).then(async () => {
    const nodeIds = selectVals.value.map(item => item.organId).join(",")
    deleteNodeInfoBatch(nodeIds).then(resData => {
      succesMsg("批量删除成功")
      tableChildRef.value.clearCheckDate()
      updateTable()// 更新表格数据
      refreshChildNode.value = true
    }).catch(errData => {
      confirmBox(errData.message)
      // dialogTitle.value = "以下节点请检查是否绑定设备，设备回收站里是否有删除的设备!"
      // deleteNodeErrTableData.value = errData.data
      // deleteNodeErrDialogOpen.value = true

    })
  }).catch(err => {

  })
}

// 获取数组下标
const findArrayIndex = (arr, key, keyName) => {
  let index = 0
  try {
    arr.forEach(item => {
      if (item[keyName] === key) {
        throw new Error('结束循环')
      } else {
        index = index + 1
      }
    })
  } catch (e) {

  }
  return index
}

// 表格分页
const curTotal = ref(0)
const curSize = ref(20)
const curPage = ref(1)

// 对话框参数
const title = ref('')
const dialogOpen = ref(false)
const dialogFormRef = ref(null)
const dialogFormData = ref([])
const dialogFormRules = {
  organName: [
    { required: true, message: '用户名称不能为空', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value.includes("~")) {
          callback(new Error('用户名称不能包含~'))
        } else {
          callback()
        }
    }, trigger: 'blur' },
  ],
  organType: [
    {
      required: true,
      message: '必须选择类型',
      trigger: 'blur'
    }
  ]
}

const formDataReset = () => {
  dialogFormData.value = {}
}

// 关闭
const closed = () => {
  // 重置数据
  dialogFormRef.value.resetFields()
  dialogOpen.value = false
}

// 迭代查找节点
const iteratinFindNode = (nodeList, organId) => {
  let retData = undefined
  if (nodeList && nodeList.length > 0) {
    nodeList.forEach(item => {
      if (item.organId === organId) {
        retData = item
      }
      if (!retData && item.child) {
        retData = iteratinFindNode(item.child, organId)
      }
    })
  }
  return retData
}

// 提交
const onConfirm = async () => {
  let _parentNode = addChild2ParentData
  dialogFormRef.value.validate(async valid => {
    // 不合规直接返回
    if (!valid) return

    let resStatus = false
    // 修改
    let updateData = null
    if (dialogFormData.value.organId) {
      if (dialogFormData.value.child) {
        updateData = { ...dialogFormData.value }
      }
      delete dialogFormData.value.child
      await nodeUpdate(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          resStatus = true
        }
      })
    } else { // 新增机构
      setParentId(_parentNode, dialogFormData.value)
      // 查询当前节点下是否有同名的子节点 
      const sameNode =  await findRootNodeByNodeType(dialogFormData.value.parentId)
      if (sameNode.data[0]?.organName == dialogFormData.value.organName) {
        alertBox(`当前节点下已存在 ${dialogFormData.value.organName} 请检查后再进行添加`, '确定', 'warning')
        return
      }
      // 添加数据
      await nodeAdd(dialogFormData.value).then(resData => {
        if (resData.status === 1) {
          if (_parentNode.organType === 'root') {
            treeOptions.value.push(resData.data)
          }
          resStatus = true
        }
      })
    }

    if (resStatus) {
      closed()

      updateTable() // 获取表格数据
      if (updateData) {
        assignmentSelfProp(curUpdateData.value, updateData) // 对象赋值
      } else {
        // 更新树结构数据
        getTreeOptions() //刷新树
        refreshNodeData.value = _parentNode
        refreshChildNode.value = true
      }
    }
  })

}
// const errCols = getCustomTableCols([
//   "eqptCode",
//   {
//     label: '错误说明',
//     prop: 'remark',
//     fontColor: 'red',
//     itemMinWidth: "250"
//   },
// ])


// 删除节点失败对话框参数
const dialogTitle = ref("")
const deleteNodeErrDialogOpen = ref(false)
const deleteNodeErrTableRef = ref(null)
const deleteNodeErrTableData = ref([])
const deleteNodeErrTableCols = [
  {
    label: '名称',
    prop: 'organName',
    itemWidth: '260',
  },
  {
    label: '地址',
    prop: 'nodeAddress',
    // itemWidth: '200',
  },
  {
    label: '户主姓名',
    prop: 'nodeUserName',
    itemWidth: '80',
  },
  {
    label: '联系电话',
    prop: 'nodeUserPhone',
    itemWidth: '120',
  },
  {
    label: '建筑面积',
    prop: 'area',
    itemWidth: '100',
  },
  {
    label: '使用面积',
    prop: 'useableArea',
    itemWidth: '100',
  },
  {
    label: '楼层',
    prop: 'floor',
    itemWidth: '80',
  },
  {
    label: '房屋性质',
    prop: 'nodeNatures',
    itemWidth: '100',
    itemType: 'natures',
    dictKey: 'natures',
  },
  {
    label: '类型',
    prop: 'organType',
    itemWidth: '100',
    itemType: 'dict',
    dictKey: 'organType',
  },
]

// 关闭删除节点对话框
const handleCloseDeleteNodeErrDialog = () => {
  deleteNodeErrDialogOpen.value = false
}

onMounted(() => {
  handleNodeClick(rootNode.value)


  watch(isShowUser, newVal => {
    if (newVal) {
      tableHeight.value = "calc(100vh - 240px)"
    } else {
      tableHeight.value = "calc(100vh - 199px)"
    }
  })
})



const distributeDataForm = ref({})
const dialogOpen_ck = ref(false)
const distributeTreeRef = ref()
const resetDistributeDataForm = () => {
  distributeDataForm.value.organId = '';
  distributeDataForm.value.organName = '';
  distributeDataForm.value.warehouseId = '';

}
const handleData = async (row,node) => {
  dialogOpen_ck.value = true
  resetDistributeDataForm() // 重置数据
  // await getAllOperation(node.organId) // 获取权限仓库
  distributeDataForm.value.organId = node.organId
  distributeDataForm.value.organName = node.organName
  // await selectWarehouseOrganRel({}).then(resData => {
  // })
  // warehouse?.forEach(item =>{
    //   arr.push(item.warehouseId)
    // })
    distributeOptions.value = warehouse
   await getAllOperation(node.organId)// 获取权限仓库
}

// 关闭分配许可
const closedDistribute = () => {
  distributeTreeRef.value.setCheckedKeys([], false)
  dialogOpen_ck.value = false
}

// 提交许可
const onConfirmDistribute = async () => {
  // 全选中节点
  const checkedKeys = distributeTreeRef.value.getCheckedKeys(false)
  let distributeIds = joinComma('', checkedKeys)

  distributeDataForm.value.warehouseId = distributeIds
  await updateWarehouseOrganRel(distributeDataForm.value).then(resData => {
    if (resData.status === 1) {
      closedDistribute()
    }
  })
}


const tableColumns = [
  {
    label: '名称',
    prop: 'organName',
    sortable: 'custom',
    itemMinWidth: '260',
  },
  {
    label: '地址',
    prop: 'nodeAddress',
    sortable: 'custom',
    itemMinWidth: '200',
  },
  {
    label: '操作时间',
    prop: 'operateTime',
    itemWidth: '160',
    itemMinWidth: '160',
    sortable: 'custom',
    itemType: 'time',
  },
  {
    label: '操作人',
    prop: 'operatorName',
    sortable: 'custom',
    itemWidth: '100',
    itemMinWidth: '100',
  },
  {
    label: '操作',
    prop: 'action',
    type: 'action',
    fixed: 'right',
    itemWidth: '220',
    search: false,
    action: [
      {
        control: 'button',
        controlType: 'text',
        controlFun: handleData,
        controlText: true,
        controlPermission: ["system::mechanismManage::distribution"],
        controlName: '仓库权限'
      },
      {
        control: 'button',
        controlType: 'text',
        controlFun: handleUpdate,
        controlText: true,
        controlPermission: ["system::mechanismManage::update"],
        controlName: '修改'
      },
      {
        control: 'button',
        controlType: 'text',
        controlFun: handleDelete,
        controlText: true,
        controlPermission: ["system::mechanismManage::delete"],
        controlName: '删除'
      }
    ]
  },
]




</script>

<style scoped lang="scss">
  .rowContainer{
    display: flex;
    .treeSide{
      position: relative;
      .resize-bar {
        width: 300px; 
        min-width: 300px; 
        height: inherit;
        resize: horizontal;
        cursor: col-resize;
        opacity: 0;
        overflow: scroll;
        max-width: 700px;
      }
      .resize-save {
        position: absolute;
        top: 0; right: 5px; bottom: 0; left: 0;
        padding: 16px;
        overflow: hidden;
      }
      .resize-line {
        position: absolute;
        right: 0; top: 0; bottom: 0;
        border-right: 1px double #bbb;
        // border-left: 1px double #bbb;
        width: 15px;
        pointer-events: none;
        display: flex;
        justify-content: center;
        align-items: center;
        .dragIcon{
          transform: rotate(90deg);
          // display: none !important;
        :deep(.svg-icon){
            width: 3em !important;
          }
        }
      }
      .resize-bar:hover ~ .resize-line,
      .resize-bar:active ~ .resize-line {
        // border-left: 1px dashed skyblue;
          border-right: 1px dashed skyblue;
      }
      .resize-bar::-webkit-scrollbar {
          width: 200px; 
          height: calc(100vh - 200px);
      }
    }
    .mainContent{
      box-sizing: border-box;
      overflow: hidden;
      flex: 1;
      padding-left: 10px;
    }
    .checkContent{
      font-size: 16px;
      font-weight: 700;
      margin-bottom:10px ;
      border-left: 3px solid #50bfff;
      border-radius: 2px;
      padding-left: 5px;
      // background:linear-gradient(to right, #ecf8ff, rgba(255, 255, 255));
    }
    .position_right{
      position: absolute;
      right: -60px;
    }
  }
</style>